import React from "react";

const MachineInfoCards = ({ machineInfo }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {machineInfo.map((info, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md p-4 border border-gray-200"
        >
          <div className="text-center text-sm font-semibold text-gray-500">{info.title}</div>
          <hr className="my-2 border-gray-300" />
          <div className="text-center text-lg font-bold text-gray-800">{info.value}</div>
        </div>
      ))}
    </div>
  );
};

export default MachineInfoCards;